import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Sectors } from './pages/Sectors';
import { SupplierRegistration } from './pages/SupplierRegistration';
import { Contact } from './pages/Contact';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { Terms } from './pages/Terms';
import { FAQ } from './pages/FAQ';
import { LogoDownload } from './pages/LogoDownload';
import { SupplierPreQualificationPrint } from './pages/SupplierPreQualificationPrint';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="w-full min-h-screen bg-navy-dark" data-id="element-2">
        <div className="print:hidden" data-id="element-3">
          <Header data-id="element-4" />
        </div>
        <Routes data-id="element-5">
          <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
          <Route path="/about" element={<About data-id="element-9" />} data-id="element-8" />
          <Route path="/services" element={<Services data-id="element-11" />} data-id="element-10" />
          <Route path="/sectors" element={<Sectors data-id="element-13" />} data-id="element-12" />
          <Route path="/supplier-registration" element={<SupplierRegistration data-id="element-15" />} data-id="element-14" />
          <Route path="/contact" element={<Contact data-id="element-17" />} data-id="element-16" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-19" />} data-id="element-18" />
          <Route path="/terms" element={<Terms data-id="element-21" />} data-id="element-20" />
          <Route path="/faq" element={<FAQ data-id="element-23" />} data-id="element-22" />
          <Route path="/brand-assets" element={<LogoDownload data-id="element-25" />} data-id="element-24" />
          <Route path="/supplier-pre-qualification-pdf" element={<SupplierPreQualificationPrint data-id="element-27" />} data-id="element-26" />
        </Routes>
        <div className="print:hidden" data-id="element-28">
          <Footer data-id="element-29" />
        </div>
      </div>
    </BrowserRouter>;
}